module.exports = __webpack_public_path__ + "static/media/icon-powerful-shot.cd1afb73.svg";